<template>
    <section class="projects">
        <div class="projects__background"></div>
        <div class="projects__container container">
            <h2 class="projects__title" v-html="title"/>
            <div class="projects__list">
                <div class="projects__wrapper">
                    <z-card
                        v-for="card in projects"
                        :key="card.id"
                        :href="card.url"
                        class="projects__card"
                        theme="primary"
                        :image="card.image"
                        :is-background-image="false"
                        :content-data="{
                            title: card.name
                        }"
                    >
                        <template v-slot:bottom>
                            <div
                                class="u-top-padding--m projects__card-content"
                                v-html="card.text"
                            />
                        </template>
                    </z-card>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { localize } from '@/utils/i18n'

defineProps({
    title: {
        type: String,
        default: localize({
            ru: 'Проекты ИНК – <br>импульс развития северных территорий',
            en: 'Our projects <br>are a driver of development in northern territories',
            cn: '我们的项目是北部地区发展的动力'
        }),
    },
    projects: {
        type: Array,
        default: () => []
    }
})
</script>

<style lang="scss">
.projects {
    margin-top: -1px; // fix white line between sections
    position: relative;
    padding: 15px 0 150px;

    @include breakpoint(v-tablet){
        padding: 15px 0 115px;
    }
    @include breakpoint(mobile){
        padding: 40px 0 75px;
    }

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 60%;
        background: linear-gradient(180deg, rgba(2, 105, 88, 0.80) 0%, rgba(2, 105, 88, 0.79) 6.67%, rgba(3, 105, 88, 0.77) 13.33%, rgba(5, 104, 87, 0.73) 20%, rgba(8, 103, 86, 0.68) 26.67%, rgba(12, 102, 85, 0.61) 33.33%, rgba(16, 101, 83, 0.53) 40%, rgba(20, 100, 82, 0.45) 46.67%, rgba(25, 99, 80, 0.35) 53.33%, rgba(29, 98, 79, 0.27) 60%, rgba(33, 97, 77, 0.19) 66.67%, rgba(37, 96, 76, 0.12) 73.33%, rgba(40, 95, 75, 0.07) 80%, rgba(42, 94, 74, 0.03) 86.67%, rgba(43, 94, 74, 0.01) 93.33%, rgba(43, 94, 74, 0.00) 100%);
        z-index: -1;
    }

    &:after {
        content: '';
        position: absolute;
        bottom: -17px;
        left: 0;
        width: 100%;
        height: 60%;
        background: linear-gradient(0deg, #0B6E5F 0%, rgba(11, 110, 95, 0.99) 6.67%, rgba(11, 110, 95, 0.96) 13.33%, rgba(11, 110, 95, 0.92) 20%, rgba(11, 110, 95, 0.85) 26.67%, rgba(11, 110, 95, 0.77) 33.33%, rgba(11, 110, 95, 0.67) 40%, rgba(11, 110, 95, 0.56) 46.67%, rgba(11, 111, 95, 0.44) 53.33%, rgba(11, 111, 95, 0.33) 60%, rgba(11, 111, 95, 0.23) 66.67%, rgba(11, 111, 95, 0.15) 73.33%, rgba(11, 111, 95, 0.08) 80%, rgba(11, 111, 95, 0.04) 86.67%, rgba(11, 111, 95, 0.01) 93.33%, rgba(11, 111, 95, 0.00) 100%);
        z-index: -1;
    }

    &__background{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 142px;
        background: linear-gradient(180deg, rgba(53, 135, 122, 0.00) 0%, #35877A 100%);
        transform: translate(0, -99%);
        pointer-events: none;
    }

    &__title{
        @include margin-level(bottom, XL);
        @include typo-level(2XL);
        font-weight: 500;
        line-height: 110%;
        color: var(--color-white);

        @include breakpoint(mobile){
             @include margin-level(bottom, L);
        }
    }

    &__list{
        @include breakpoint(v-tablet){
            margin-right: -$token-grids-v-tablet-offset;
            margin-left: -$token-grids-v-tablet-offset;
            max-width: calc(100% + $token-grids-v-tablet-offset * 2);
            overflow: scroll;

            &::-webkit-scrollbar{
                display: none;
            }
        }

        @include breakpoint(mobile){
            margin-right: -$token-grids-mobile-offset;
            margin-left: -$token-grids-mobile-offset;
            max-width: calc(100% + $token-grids-mobile-offset * 2);
        }

    }

    &__wrapper{
        display: flex;
        @include gap-level(M);

        @include breakpoint(v-tablet){
            padding-right: $token-grids-v-tablet-offset;
            padding-left: $token-grids-v-tablet-offset;
            width: max-content;
        }
        @include breakpoint(mobile){
            padding-right: $token-grids-mobile-offset;
            padding-left: $token-grids-mobile-offset;
        }
    }
    &__card{
        @include breakpoint(v-tablet){
            max-width: 426px;
        }

        @include breakpoint(mobile){
            max-width: 81.3vw;
        }

        &-content{
            & ul{
                margin: 0;
            }
        }


        & .z-card__content{
            flex-direction: column;
        }

        & .z-image{
            width: 100%;
            height: 100%;
            border-radius: 20px 20px 0 0;
            & img {
                width: 100%;
                height: 100%;
                max-height: 100%;
                object-fit: cover;
            }
        }
    }
}
</style>
